import { apiServerRoutes } from "../constants/apiRoutes";
import { getAPICallServer, postAPICallServer } from "../utils/axios.util";

class SearchService {
  async search(req: any) {
    const data = req.body;
    const page = req.body.page;
    delete req.body.page;

    return postAPICallServer(
      `${apiServerRoutes.SEARCH_LISTING}page=${page}`,
      data ?? {},
      req
    );
  }
  async searchListingDetails(req: any) {
    const { id } = req.body;

    return getAPICallServer(
      `${apiServerRoutes.SEARCH_DETAILS.replace(":id", id)}`,
      req
    );
  }
  async searchListingDetailsOwner(req: any) {
    const { id } = req.body;

    return getAPICallServer(
      `${apiServerRoutes.SEARCH_DETAILS_OWNER.replace(":id", id)}`,
      req
    );
  }
}

export default new SearchService();
